import React from 'react';
import PropTypes from 'prop-types';
// Model
import mDistribution from 'models/distribution';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import { listFeatureSearchFieldShape, listFilterShape } from 'constants/PropTypesShapes';
import { dateGenerator } from 'utils/DateUtils';
// Components
import FiltersTemplate from 'components/templates/FiltersTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';
import DateFilter from 'components/filters/DateFilter';
import ItemsSelectFieldFilter from 'components/filters/ItemsSelectFieldFilter';

const DistributionFilters = ({
  disabled, advanced, nbFiltersApplied, searchFields, field, filters,
  isFieldDisplayable, onFieldChange, onFilterFieldChange, onReinit, onSwitch,
}) => {
  const {
    version, begin, end, type,
  } = filters;
  // Dates
  const beginDate = dateGenerator.date(begin.value);
  const endDate = dateGenerator.date(end.value);

  return (
    <FiltersTemplate
      disabled={disabled}
      advanced={advanced}
      nbFiltersApplied={nbFiltersApplied}
      onReinit={onReinit}
      onSwitch={onSwitch}
    >
      <div className="row m-0 pb-3">
        {!advanced && (
          <div className="col-12 col-md-4 col-xl-3">
            <BaseListFilter
              field={field}
              searchFields={searchFields}
              onChange={onFieldChange}
            />
          </div>
        )}
        {isFieldDisplayable('type') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.type"
              value={type.value}
              items={mDistribution.typesList}
              onChange={(value) => onFilterFieldChange('type', value)}
            />
          </div>
        )}
        {isFieldDisplayable('version') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.version"
              value={version.value}
              onChange={(value) => onFilterFieldChange('version', value)}
            />
          </div>
        )}
        {isFieldDisplayable('begin') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DateFilter
              labelId="field.afterDate"
              type="begin"
              value={beginDate}
              onChange={(value) => onFilterFieldChange('begin', value)}
            />
          </div>
        )}
        {isFieldDisplayable('end') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DateFilter
              labelId="field.beforeDate"
              type="end"
              value={endDate}
              onChange={(value) => onFilterFieldChange('end', value)}
            />
          </div>
        )}
      </div>
    </FiltersTemplate>
  );
};

DistributionFilters.propTypes = {
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    version: listFilterShape,
    begin: listFilterShape,
    end: listFilterShape,
    type: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(mDistribution.listFeatures.searchFields)(DistributionFilters);



// WEBPACK FOOTER //
// ./routes/app/routes/distributions/assets/main/DistributionFilters.js